import React, { useEffect, useState } from "react";
import "../Assets/Css/Teachers.css";
import prevArrow from "../Assets/Images/Dashboard/prev_icon.png";
import nextArrow from "../Assets/Images/Dashboard/next_icon.png";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import upArrow from "../Assets/Images/Dashboard/up_arrow.png";
import downArrow from "../Assets/Images/Dashboard/down_arrow.png";
import profile_pic from "../Assets/Images/Dashboard/default_profile.svg";
import school_image from "../Assets/Images/Dashboard/schoolDummyLogo.png";
import Sidebar from "../Component/Sidebar";
import Loader from "../Component/Loader";
// import TeacherTransferIcon from "../Assets/Images/Sidebar/teacher_transfer_icon.svg";
import { Link } from "react-router-dom";
import {
  TEACHER_LIST_GET_API,
  API_START_POINT,
  SCHOOL_LIST_GET_API,
} from "../Component/AllApi";
// import Select from "react-select";

import { toast } from "react-toastify";
import ExportToExcel from "../Component/ExportToExcel";

const Teachers = () => {
  const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    "& .MuiSwitch-track": {
      borderRadius: 22 / 2,
      backgroundColor: theme.palette.mode === "dark" ? "#63D92C" : "#7C0D0D",
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "none",
      width: 16,
      height: 16,
      margin: 2,
      backgroundColor: "#fff",
    },
  }));

  const itemsPerPage = 10;
  const [token, setToken] = useState(localStorage.getItem("authToken"));
  const [userRole, setUserRole] = useState(localStorage.getItem("user_role"));
  const [user, setUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortKey, setSortKey] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [toggleStates, setToggleStates] = useState(
    // false || new Array(itemsPerPage).fill(false)
    []
  );

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(TEACHER_LIST_GET_API, {
        method: "GET",
        headers: {
          Authorization: `bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Something went wrong");
      }
      // role based fetch
      let data;
      if (userRole === "Admin") {
        const { allTrainers } = await response.json();
        // console.log("Admin trainer data:", allTrainers);
        data = allTrainers;
      } else if (userRole === "Principal") {
        const { schoolTrainers } = await response.json();
        // console.log("Principal trainer data:", schoolTrainers);
        data = schoolTrainers;
      } else if (userRole === "Diet") {
        const { dietTrainers } = await response.json(); // Replace with actual data key
        // console.log("DIET trainer data:", dietTrainers);
        data = dietTrainers;
      } else {
        console.error("Unknown role:", userRole);
        return;
      }

      //setting the data
      setUser(data);
      // const initialToggleState = data.map(
      //   (trainer) => trainer.tra_is_active === 1
      // );
      // setToggleStates(initialToggleState);
      const initialToggleState = data.reduce((acc, trainer) => {
        acc[trainer.tra_id] = trainer.tra_is_active === 1;
        return acc;
      }, {});
      setToggleStates(initialToggleState);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Ensure latest token and userRole are set before fetching data
    setToken(localStorage.getItem("authToken"));
    setUserRole(localStorage.getItem("user_role"));

    if (token && userRole) {
      fetchData();
      // fetchSchools();
    }
  }, [token, userRole]);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleToggle = async (index, trainerID) => {
    // console.log("index: ", index + "trainerID: ", trainerID);
    // const newToggleStates = [...toggleStates];
    // const currentToggleState = newToggleStates[index];
    // newToggleStates[index] = !currentToggleState;
    // setToggleStates(newToggleStates);
    const currentToggleState = toggleStates[trainerID];
    const newToggleStates = { ...toggleStates };
    newToggleStates[trainerID] = !newToggleStates[trainerID];
    setToggleStates(newToggleStates);

    // console.log("newToggleStates: ", newToggleStates[trainerID]);
    try {
      // const newToggleStates = [...toggleStates];
      // newToggleStates[index] = !newToggleStates[index];
      // setToggleStates(newToggleStates);

      const response = await fetch(
        `${API_START_POINT}/trainers/${trainerID}/toggle-active`,
        {
          method: "PUT",
          headers: {
            Authorization: `bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            // tra_is_active: newToggleStates[index] ? 1 : 0,
            tra_is_active: newToggleStates[trainerID] ? 1 : 0,
          }),
        }
      );
      // console.log("toggle", response);
      // console.log("tra active", newToggleStates[trainerID]);
      if (!response.ok) {
        throw new Error("Failed to Update");
      }
      //if data is updated change the data
      fetchData();
    } catch (err) {
      console.error("Error occured", err);
      alert("Something went wrong. Please try again.");
      // newToggleStates[index] = currentToggleState;
      // setToggleStates(newToggleStates);

      // prev working
      // newToggleStates[trainerID] = !newToggleStates[trainerID];
      // setToggleStates(newToggleStates);
      const revertedToggleStates = {
        ...newToggleStates,
        [trainerID]: currentToggleState,
      };
      setToggleStates(revertedToggleStates);
      // fetchData();
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
    // fetchData();
  };

  const handleSort = (key) => {
    if (sortKey === key) {
      // If already sorted by this key, toggle the order
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      // If sorting by a new key, set it and default to ascending order
      setSortKey(key);
      setSortOrder("asc");
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const filteredUsers = user.filter((userData) => {
    const query = searchQuery.toLowerCase();
    return (
      (userData.tra_name && userData.tra_name.toLowerCase().includes(query)) ||
      (userData.school_name &&
        userData.school_name.toLowerCase().includes(query)) ||
      (userData.tra_address &&
        userData.tra_address.toLowerCase().includes(query)) ||
      (userData.tra_phone && userData.tra_phone.includes(query))
    );
  });

  const paginatedUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

  const sortedUsers = sortKey
    ? paginatedUsers.sort((a, b) => {
        // Sort function based on the current sort key and order
        const aValue = String(a[sortKey]).toLowerCase();
        const bValue = String(b[sortKey]).toLowerCase();
        if (aValue < bValue) return sortOrder === "asc" ? -1 : 1;
        if (aValue > bValue) return sortOrder === "asc" ? 1 : -1;
        return 0;
      })
    : paginatedUsers;

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const totalItems = filteredUsers.length;
  const PagePerItem = Math.min(totalItems - indexOfFirstItem, indexOfLastItem);
  const rangeStart = Math.min((currentPage - 1) * itemsPerPage + 1, totalItems);
  const rangeEnd = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <>
      <Sidebar />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <section className="schoolListSection">
            <div className="sidebody">
              <div className="container">
                {/* Your main_div */}
                <div className="main_div">
                  <div
                    className="schListHeader_div"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {/* Your header_text and search_div */}
                    <div className="schListHeader_text">
                      <p>Teachers</p>
                    </div>
                    <div className="d-flex">
                    <div>
                        <ExportToExcel
                          data={user}
                          fileName="Teachers_list"
                          sheetName="Teachers"
                          columns={[
                            { key: "tra_name", alias: "Teacher Name" },
                            { key: "tra_phone", alias: "Phone Number" },
                            { key: "tra_email", alias: "Email" },
                            { key: "tra_address", alias: "Address" },
                            { key: "tra_qualification", alias: "Qualification" },
                            { key: "school_name", alias: "School" },
                            { key: "school_loc", alias: "School Address" },
                          ]}
                        />
                      </div>
                      <div className="searchBar" >
                        <form className="d-flex">
                          <input
                            className="form-control me-2"
                            type="search"
                            placeholder="Search"
                            aria-label="Search"
                            onChange={handleSearch}
                            style={{ borderRadius: "12px", border: "none" }}
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                  {/* Your content table-responsive */}
                  {sortedUsers?.length < 0 || sortedUsers?.length == 0 ? (
                    <>
                      <p className="progressMainTitle text-center">
                        No data available
                      </p>
                    </>
                  ) : (
                    <div
                      className="card schoolListTableDiv"
                      style={{ border: "none" }}
                    >
                      <div
                        className=" table-responsive  card-body"
                        // style={{ maxHeight: "750px" }}
                      >
                        <table className="table table-borderless table-responsive">
                          <thead
                            style={{ marginBottom: "20px" }}
                            className="thead_div"
                          >
                            <tr>
                              <th
                                // style={{ width: "6%" }}
                                className="thead_div_row pb-4"
                              >
                                Sr.
                              </th>
                              <th
                                scope="col"
                                style={{ textAlign: "left" }}
                                className="thead_div_row pb-4"
                              >
                                Teacher &nbsp;
                                <button
                                  className="sort_button"
                                  onClick={() => handleSort("tra_name")}
                                  // style={{marginLeft:"4px"}}
                                >
                                  <img
                                    src={
                                      sortKey === "tra_name" &&
                                      sortOrder === "asc"
                                        ? downArrow
                                        : upArrow
                                    }
                                    className="desc"
                                    style={{ marginRight: "15px" }}
                                    alt="arrows"
                                  />
                                </button>
                              </th>
                              <th
                                scope="col"
                                className="thead_div_row pb-4"
                                // style={{ width: "15%" }}
                              >
                                School Name &nbsp;
                                <button
                                  className="sort_button"
                                  onClick={() => handleSort("school_name")}
                                >
                                  {" "}
                                  <img
                                    src={
                                      sortKey === "school_name" &&
                                      sortOrder === "asc"
                                        ? downArrow
                                        : upArrow
                                    }
                                    className="desc"
                                    style={{ marginRight: "15px" }}
                                    alt="arrows"
                                  />
                                </button>{" "}
                              </th>
                              <th
                                scope="col"
                                className="thead_div_row pb-4"
                                // style={{ width: "15%" }}
                              >
                                Teacher Mobile
                              </th>
                              <th
                                scope="col"
                                className="thead_div_row pb-4"
                                // style={{ width: "10%" }}
                              >
                                Location{" "}
                              </th>

                              {/* {userRole === "Admin" && (
                                <th
                                  scope="col"
                                  className="thead_div_row pb-4 ps-4"
                                  
                                >
                                  Authorization (Active User)
                                </th>
                              )} */}
                              {/* {(userRole === "Principal" ||
                                userRole === "Diet") && (
                                  <th
                                    scope="col"
                                    className="thead_div_row pb-4 ps-4"
                                    // style={{ width: "5%" }}
                                  >
                                    Ass. attempts
                                  </th>
                                )}
                              {(userRole === "Principal" ||
                                userRole === "Diet") && (
                                  <th
                                    scope="col"
                                    className="thead_div_row pb-4 ps-4"
                                    // style={{ width: "5%" }}
                                  >
                                    Ass. Score
                                  </th>
                                )} */}
                            </tr>
                          </thead>
                          <tbody>
                            {sortedUsers.map((userData, index) => (
                              <tr key={index}>
                                <td
                                  className="header_srNo"
                                  style={{ paddingBottom: "36px" }}
                                >
                                  {index + indexOfFirstItem + 1}
                                </td>
                                <td className="d-flex">
                                  <Link
                                    to="/teacherParticularData"
                                    style={{ textDecoration: "none" }}
                                    onClick={() => {
                                      localStorage.setItem(
                                        "trainer_id",
                                        userData.tra_id
                                      );
                                      localStorage.setItem(
                                        "trainer_name",
                                        userData.tra_name
                                      );
                                    }}
                                    state={{
                                      trainerId: userData.tra_id,
                                      school_name: userData.school_name,
                                      referrer: "/teachers",
                                    }}
                                  >
                                    <img
                                      src={
                                        userData.tra_image === null ||
                                        userData.tra_image === ""
                                          ? profile_pic
                                          : userData.tra_image
                                      }
                                      style={{
                                        width: "24px",
                                        height: "24px",
                                      }}
                                      onError={(e) => {
                                        e.target.src = profile_pic;
                                      }}
                                      alt="profilePic"
                                    />

                                    <span className="allocatedTeacher ms-2">
                                      {userData.tra_name}
                                    </span>
                                  </Link>
                                  {/* {!toggleStates[userData.tra_id] && (
                                    <span className="new_mark ms-2">New</span>
                                  )} */}
                                </td>
                                <td className="schoolname_text">
                                  <div className="d-flex">
                                    <img
                                      src={school_image}
                                      style={{
                                        width: "24px",
                                        height: "24px",
                                        marginRight: "13px",
                                      }}
                                      alt="schoolImg"
                                    />
                                    {userData.school_name}
                                  </div>
                                </td>
                                <td className="teacher_mobile">
                                  {userData.tra_phone}
                                </td>
                                <td className="location_text">
                                  {userData.tra_address}
                                </td>

                                {/* {userRole === "Admin" && (
                                  <td>
                                    <div className="row">
                                      {
                                        <div className="col-5 first_status">
                                          <p
                                            style={{
                                              fontWeight: "600",
                                            }}
                                     
                                            className={
                                              !toggleStates[userData.tra_id]
                                                ? "red-text"
                                                : "grey-text"
                                            }
                                          >
                                            Inactive
                                          </p>
                                        </div>
                                      }
                                      <div className="col-2 dial_div">
                                        <FormControlLabel
                                          style={{ marginTop: "-10px" }}
                                          control={
                                            <Android12Switch
                                              checked={
                                                toggleStates[userData.tra_id] ||
                                                false
                                              }
                                              onChange={() =>
                                                handleToggle(
                                                  index + indexOfFirstItem,
                                                  userData.tra_id
                                                )
                                              }
                                            />
                                          }
                                        />
                                      </div>
                                      <div className="col-5 second_status">
                                        <p
                                          className={
                                            toggleStates[userData.tra_id]
                                              ? "green-text"
                                              : "grey-text"
                                          }
                                        >
                                          Active
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                )} */}
                                {/* {(userRole === "Principal" ||
                                  userRole === "Diet") && (
                                    <td style={{ textAlign: "center" }}>
                                      {userData.tra_assessment_attempt
                                        ? userData.tra_assessment_attempt
                                        : "-"}
                                    </td>
                                  )}
                                {(userRole === "Principal" ||
                                  userRole === "Diet") && (
                                    <td style={{ textAlign: "center" }}>
                                      {userData.tra_assessment_score
                                        ? userData.tra_assessment_score
                                        : "-"}
                                    </td>
                                  )} */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div
                        className="footer card-footer"
                        style={{ marginTop: "12px" }}
                      >
                        <div className="row">
                          {
                            <div className="result_msg_text col-lg-7 col-sm-7 sol-12">
                              Displaying {rangeEnd} results of {totalItems}
                            </div>
                          }
                          <div className="button_module col-12 col-lg-5 col-sm-5 col-md-5 d-flex ">
                            <div
                              className="dropdown d-flex"
                              style={{
                                alignItems: "center",
                                marginRight: "10px",
                              }}
                            >
                              <p className="paginate_msg_text">Page</p>
                              <select
                                value={currentPage}
                                onChange={(e) =>
                                  setCurrentPage(Number(e.target.value))
                                }
                                className="select_page"
                                style={{
                                  marginRight: "8px",
                                  marginLeft: "16px",
                                }}
                              >
                                {Array.from({ length: totalPages }, (_, i) => (
                                  <option key={i + 1} value={i + 1}>
                                    {i + 1}
                                  </option>
                                ))}
                              </select>
                              <span className="paginate_msg_text">
                                of {totalPages}
                              </span>
                            </div>
                            <div className="d-flex">
                              <button
                                type="button"
                                className="bton"
                                onClick={prevPage}
                                disabled={currentPage === 1}
                              >
                                <img
                                  src={prevArrow}
                                  alt="prev"
                                  className="arrow_btn"
                                />
                              </button>

                              <button
                                type="button"
                                className="bton"
                                onClick={nextPage}
                                disabled={currentPage === totalPages}
                              >
                                <img
                                  src={nextArrow}
                                  alt="next"
                                  className="arrow_btn"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default Teachers;
